package devxertech.com.pages.career.devxerCareer

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextOverflow
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textOverflow
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.Page
import devxertech.com.seo.PageMetadataForCurrentRoute
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.CommonButton
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.component.UnderlinedTextField
import devxertech.com.models.Attachment
import devxertech.com.models.SendEmailPayload
import devxertech.com.models.SendEmailResponse
import devxertech.com.pages.commons.UpdatedButton
import devxertech.com.pages.contactSection.Country
import devxertech.com.pages.contactSection.detectUserCountryISO
import devxertech.com.pages.contactSection.fetchCountries
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.section.SideBar
import devxertech.com.section.TopBar
import devxertech.com.theme.Palette
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.APIMETHODS
import devxertech.com.utils.Constants
import devxertech.com.utils.Grecaptcha
import devxertech.com.utils.loadRecaptcha
import devxertech.com.utils.httpJsonRequest
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input
import org.w3c.dom.HTMLInputElement

@Page("/Hr-Intern")
@Composable
fun HrIntern() {
    PageMetadataForCurrentRoute()
    val scope = rememberCoroutineScope()
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    var emailInput by remember { mutableStateOf("") }
    var nameInput by remember { mutableStateOf("") }
    var contactInput by remember { mutableStateOf("") }
    var positionInput by remember { mutableStateOf("") }
    var isSideMenuOpen by remember { mutableStateOf(false) }
    var selectedFileName by remember { mutableStateOf<String?>(null) }

    var isSubmitting by remember { mutableStateOf(false) }
    var phoneNumber by remember { mutableStateOf("") }

    var nameError by remember { mutableStateOf<String?>(null) }
    var emailError by remember { mutableStateOf<String?>(null) }
    var contactError by remember { mutableStateOf<String?>(null) }
    var positionError by remember { mutableStateOf<String?>(null) }
    var fileError by remember { mutableStateOf<String?>(null) }

    var selectedFileBase64 by remember { mutableStateOf<String?>(null) }
    var selectedFileType by remember { mutableStateOf<String?>(null) }
    var countries by remember { mutableStateOf<List<Country>>(emptyList()) }
    var selectedCountry by remember { mutableStateOf<Country?>(null) }

    LaunchedEffect(Unit) {
        val all = fetchCountries()
        countries = all

        // auto detect user country
        val iso = detectUserCountryISO()
        selectedCountry = selectedCountry ?: all.firstOrNull { it.iso == iso } ?: all.firstOrNull()
    }
    val allowedFileTypes = listOf(
        "application/pdf",
        "application/msword", // .doc
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" // .docx
    )


    fun validateForm(): Boolean {
        nameError = null
        emailError = null
        contactError = null
        positionError = null
        fileError = null

        if (nameInput.isBlank()) {
            nameError = "Name is required"
            return false
        }

        if (emailInput.isBlank()) {
            emailError = "Email is required"
            return false
        }

        if (!emailInput.matches(Regex("^[A-Za-z0-9+_.-]+@(.+)$"))) {
            emailError = "Invalid email address"
            return false
        }

        val digitsOnly = phoneNumber.filter { it.isDigit() }

        if (digitsOnly.isBlank()) {
            contactError = "Contact number is required"
            return false
        }

        if (digitsOnly.length !in 7..14) {
            contactError = "Contact number must be 7 to 14 digits"
            return false
        }

        if (positionInput.isBlank()) {
            positionError = "Position is required"
            return false
        }

        if (selectedFileBase64 == null || selectedFileType == null) {
            fileError = "CV file is required"
            return false
        }

        if (selectedFileType !in allowedFileTypes) {
            fileError = "Only PDF or Word documents are allowed"
            return false
        }
        return true
    }

    if (isSideMenuOpen || breakpoint < Breakpoint.XL) {
        SideBar(breakpoint = breakpoint, isOpen = isSideMenuOpen, onClose = { isSideMenuOpen = false }, showExtraText = true)
    }

    Column(
        modifier = Modifier.backgroundColor(Palette.White.rgbLight)
    ) {
        TopBar(
            breakpoint = breakpoint,
            onMenuClick = { isSideMenuOpen = true },
            careerPageShadow = true,
            alwaysHovered = true
        )
        Row(
            modifier = Modifier.fillMaxWidth().margin(top = 120.px)
                .padding(
                    leftRight = if (breakpoint <= Breakpoint.MD) 0.px
                    else if (breakpoint == Breakpoint.LG) 25.px else 100.px
                ),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = if (breakpoint <= Breakpoint.MD) Arrangement.Center else Arrangement.Start
        ) {
            CommonButton(
                " Back To Careers",
                onClick = {},
                linkPath = "/career-page",
                isCareerButton = true
            )
        }
        Column(
            modifier = Modifier.fillMaxWidth(),
        ) {
            Row(
                modifier = Modifier.fillMaxWidth()
                    .padding(
                        left = if (breakpoint < Breakpoint.MD) 5.px
                        else if (breakpoint == Breakpoint.MD) 0.px
                        else if (breakpoint == Breakpoint.LG) 25.px else 100.px
                    )
                    .margin(top = if (breakpoint < Breakpoint.MD) 10.px else 30.px),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = if (breakpoint <= Breakpoint.MD) Arrangement.Center else Arrangement.Start
            ) {
                FieldTitleTextNormalSimple(
                    text = "HR INTERN",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    letterSpacing = 0.3.px,
                    fontSize = 40.px,
                    textAlign = TextAlign.Center,
                    fontWeight = 700,
                    textTransform = TextTransform.Uppercase,
                    marginBottom = 8.px,
                    asH1 = true

                )
            }
        }
        Row(
            modifier = Modifier.fillMaxWidth().flexWrap(FlexWrap.Wrap)
                .padding(
                    left = if (breakpoint < Breakpoint.MD) 5.px
                    else if (breakpoint == Breakpoint.MD) 0.px
                    else if (breakpoint == Breakpoint.LG) 25.px else 100.px
                ),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = if (breakpoint <= Breakpoint.MD) Arrangement.Center else Arrangement.Start
        ) {
            FieldTitleTextNormalSimple(
                text = "Apply before 14-10-2026",
                color = sitePalette.primary.rgb,
                fontFamily = Constants.ROBOTO_FONT,
                fontSize = if (breakpoint < Breakpoint.MD) 20.px else 25.px,
                fontWeight = 500,
            )
            FieldTitleTextNormalSimple(
                text = " | ",
                color = sitePalette.commonSecondaryButtonColor.rgb,
                fontFamily = Constants.ROBOTO_FONT,
                fontSize = if (breakpoint < Breakpoint.MD) 20.px else 25.px,
                fontWeight = 500,
                paddingBottom = 3.px
            )
            FieldTitleTextNormalSimple(
                text = "Total Positions: 2",
                color = sitePalette.primary.rgb,
                fontFamily = Constants.ROBOTO_FONT,
                fontSize = if (breakpoint < Breakpoint.MD) 20.px else 25.px,
                fontWeight = 500,
            )
        }




        Row(
            modifier = Modifier.fillMaxWidth().flexWrap(FlexWrap.Wrap),
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            // Left Column: Job Description
            Column(
                modifier = Modifier.width(if (breakpoint <= Breakpoint.MD) 100.percent else 50.percent)
                    .padding(bottom = 50.px),
                horizontalAlignment = Alignment.Start
            ) {
                SectionContent(text = "We are looking to employ an enthusiastic and driven HR intern to assist our HR department with administrative and HR-related tasks.")
                SectionContent(
                    text = "The HR intern’s responsibilities include updating employee absence records, filing HR documents accordingly, " +
                            "and initiating background checks.", isParagraph = true
                )
                SectionContent(
                    text = "You should also be able to draft employee communications " +
                            "notifying staff of policy and procedural changes.", isParagraph = true
                )

                SectionContent(text = "HR Intern Responsibilities:")
                SectionContent(
                    text = "Updating company databases by inputting new employee contact " +
                            "information and employment details.", isParagraph = true
                )
                SectionContent(
                    text = "Screening potential employees’ resumes and application forms.",
                    isParagraph = true
                )
                SectionContent(
                    text = "Organizing interviews with shortlisted candidates.",
                    isParagraph = true
                )
                SectionContent(
                    text = "Posting job advertisements to job boards and social media platforms.",
                    isParagraph = true
                )
                SectionContent(
                    text = "Assisting in the planning of company events.",
                    isParagraph = true
                )
                SectionContent(
                    text = "Preparing and sending offer and rejection letters.",
                    isParagraph = true
                )
                SectionContent(text = "Coordinating new hire orientations.", isParagraph = true)
                SectionContent(
                    text = "Maintaining a database of passive candidates.",
                    isParagraph = true
                )

                SectionContent(text = "HR Intern Requirements:", isParagraph = true)
                SectionContent(
                    text = "Bachelor’s degree or pursuing a degree in HR management or related field.",
                    isParagraph = true
                )
                SectionContent(
                    text = "Familiarity with HRIS (Human Resources Information System) software.",
                    isParagraph = true
                )
                SectionContent(
                    text = "Proficiency in Microsoft Office applications.",
                    isParagraph = true
                )
                SectionContent(text = "The ability to work as part of a team.", isParagraph = true)
                SectionContent(
                    text = "Strong analytical and problem-solving skills.",
                    isParagraph = true
                )
                SectionContent(
                    text = "Excellent administrative and organizational skills.",
                    isParagraph = true
                )
                SectionContent(text = "Effective communication skills.", isParagraph = true)
                SectionContent(text = "Detail-oriented.", isParagraph = true)

                SectionContent(text = "Experience:")
                SectionContent(text = "Min 2 Years", isParagraph = true)

                val textFontSize = when {
                    window.screen.width > 1600 -> 18.px
                    window.screen.width == 1440 -> 16.px
                    window.screen.width == 1024 -> 15.px
                    window.screen.width <= 768 -> 13.px
                    else -> 15.px
                }
                val paddingLeft = when {
                    window.screen.width == 1024 -> 25.px
                    window.screen.width <= 768 -> 40.px
                    else -> 100.px
                }

                SectionContent(text = "About Us:")
                FieldTitleTextNormalSimple(
                    text = "Devxer is a full services technology company with having presence in Lahore Over the past 18+ years, we have matured from a narrowly-focused five-person team to a well-established technology hub with around employees. \n" +
                            "The success of our business mainly lies in building a team of A-players, who work together and build together, and who crave perfection in everything they produce for our elite clients. " +
                            "We offer the opportunity to young and enthusiastic individuals that are eager to take on tough challenges under our mentorship toward a bright future.",
                    width = if (breakpoint == Breakpoint.LG) 100.percent else 90.percent,
                    paddingLeft = paddingLeft,
                    color = Palette.Black.rgbLight,
                    fontFamily = Constants.FONT_FAMILY,
                    fontSize = textFontSize,
                    fontWeight = if (breakpoint > Breakpoint.MD) 300 else 200,
                    textAlign = TextAlign.Left,
                    whiteSpace = WhiteSpace.PreWrap,


                    )
            }

//            Right Submit Form
            val placeholderModifier =
                Modifier.fontSize(if (breakpoint > Breakpoint.LG) 19.px else 16.px)
                    .fontWeight(FontWeight.Medium)
                    .fontFamily(Constants.FONT_FAMILY)
                    .color(sitePalette.bodyBackground.rgb)
                    .padding(left = 5.px)
            val fontSize = when {
                window.screen.width >= 1400 -> 29.px
                window.screen.width == 1024 -> 22.px
                window.screen.width in 400..800 -> 25.px
                window.screen.width in 375..400 -> 22.px
                else -> 19.px
            }
            Column(
                modifier = Modifier
                    .width(
                        when {
                            window.screen.width > 1600 -> 30.percent
                            window.screen.width == 1440 -> 37.percent
                            window.screen.width == 1024 -> 40.percent
                            window.screen.width <= 768 -> 100.percent
                            else -> 50.percent
                        }
                    )
                    .padding(
                        right = if (breakpoint <= Breakpoint.MD) (-30).px else 130.px,
                        top = 30.px
                    )
                    .margin(bottom = if (breakpoint <= Breakpoint.MD) 40.px else 0.px)
                    .flexWrap(FlexWrap.Wrap),
                horizontalAlignment = if (breakpoint <= Breakpoint.MD) Alignment.CenterHorizontally else Alignment.End,
                verticalArrangement = Arrangement.Center
            ) {
                Box(
                    modifier = Modifier
                        .width(
                            when {
                                window.screen.width > 1440 -> 470.px
                                window.screen.width == 1440 -> 450.px
                                window.screen.width == 1024 -> 350.px
                                window.screen.width > 768 -> 63.percent
                                window.screen.width == 768 -> 55.percent
                                else -> 90.percent
                            }
                        )
                        .height(
                            if (breakpoint == Breakpoint.LG) 620.px
                            else if (breakpoint > Breakpoint.MD) 700.px
                            else 575.px
                        )
                        .backgroundColor(sitePalette.careerLight.rgb)
                        .borderRadius(29.px)
                        .boxShadow(
                            blurRadius = 4.px,
                            offsetX = 0.px,
                            offsetY = 4.px,
                            spreadRadius = 0.px,
                            color = sitePalette.specialButtonBorderColor.rgb
                        ),
                    contentAlignment = Alignment.Center
                ) {
                    Column(
                        modifier = Modifier.fillMaxSize()
                            .padding(
                                if (breakpoint == Breakpoint.LG) 40.px
                                else if (breakpoint > Breakpoint.MD) 50.px
                                else 30.px
                            ).gap(40.px)
                    ) {

                        SpanText(
                            text = "Submit Your Application",
                            modifier = Modifier
                                .padding(top = if (breakpoint < Breakpoint.MD) 15.px else 25.px)
                                .color(sitePalette.bodyBackgroundSecondary.rgb)
                                .fontWeight(FontWeight.Bold)
                                .fontFamily(Constants.FONT_FAMILY)
                                .lineHeight(if (breakpoint > Breakpoint.MD) 37.px else 30.px)
                                .fontSize(fontSize)
                                .letterSpacing(0.5.px)
                        )
                        Column(
                            modifier = Modifier.fillMaxWidth().gap(if (breakpoint < Breakpoint.MD)36.px else 38.px),
                            verticalArrangement = Arrangement.Center,
                        ) {
                           Column(modifier = Modifier.width(100.percent).margin(top = (-10).px)
                               .height(60.px)) {
                                UnderlinedTextField(
                                    value = nameInput,
                                    onTextChange = {
                                        nameInput = it
                                        nameError = null
                                    },
                                    placeholder = "Enter name",
                                    placeholderModifier = placeholderModifier
                                )
                                if (nameError != null) {
                                    SpanText(
                                        text = nameError!!,
                                        modifier = Modifier
                                            .color(sitePalette.textRedColor.rgb)
                                            .fontSize(13.px).margin(top = 3.px)
                                    )
                                }
                            }
                           Column(modifier = Modifier.width(100.percent).margin(top = (-22).px)
                               .height(60.px)) {
                                UnderlinedTextField(
                                    value = emailInput,
                                    onTextChange = {
                                        emailInput = it
                                        emailError = null
                                    },
                                    placeholder = "Enter email",
                                    placeholderModifier = placeholderModifier
                                )
                                if (emailError != null) {
                                    SpanText(
                                        text = emailError!!,
                                        modifier = Modifier
                                            .color(sitePalette.textRedColor.rgb)
                                            .fontSize(13.px).margin(top = 3.px)
                                    )
                                }
                            }
                           Column(modifier = Modifier.width(100.percent).margin(top = (-22).px)
                               .height(60.px)) {
                               UnderlinedPhoneInputWithFlagCountry(
                                   countries = countries,
                                   selectedCountry = selectedCountry,
                                   onCountryChange = { selectedCountry = it },
                                   phone = phoneNumber,
                                   onPhoneChange = {
                                       phoneNumber = it
                                       contactInput = it
                                   },
                                   onError = { contactError = it },
                                   placeholder = "Enter number",
                               )
                                if (contactError != null) {
                                    SpanText(
                                        text = contactError!!,
                                        modifier = Modifier
                                            .color(sitePalette.textRedColor.rgb)
                                            .fontSize(13.px).margin(top = 3.px)
                                    )
                                }
                            }
                           Column(modifier = Modifier.width(100.percent).margin(top = (-22).px)
                               .height(60.px)) {
                                UnderlinedTextField(
                                    value = positionInput,
                                    onTextChange = {
                                        positionInput = it
                                        positionError = null
                                    },
                                    placeholder = "Apply for position",
                                    placeholderModifier = placeholderModifier
                                )
                                if (positionError != null) {
                                    SpanText(
                                        text = positionError!!,
                                        modifier = Modifier
                                            .color(sitePalette.textRedColor.rgb)
                                            .fontSize(13.px).margin(top = 3.px)
                                    )
                                }
                            }
                            Column(modifier = Modifier.width(100.percent).margin(top = (-10).px)
                                .height(60.px)) {
                                FileUploadRow(
                                    breakpoint = breakpoint,
                                    selectedFileName = selectedFileName
                                ) { name, type, base64 ->
                                    selectedFileName = name
                                    selectedFileType = type
                                    selectedFileBase64 = base64
                                    fileError = null
                                }
                                if (fileError != null) {
                                    SpanText(
                                        text = fileError!!,
                                        modifier = Modifier
                                            .color(sitePalette.textRedColor.rgb)
                                            .fontSize(13.px).margin(top = 3.px)
                                    )
                                }
                            }
                            Column(modifier = Modifier.fillMaxWidth().margin(top = if(breakpoint < Breakpoint.MD) (-20).px else (-10).px)) {
                                val dialCode = selectedCountry?.dialCode ?: ""
                                val fullContact = "$dialCode $phoneNumber"

                                UpdatedButton(
                                    text = "Send Application",
                                    isLoading = isSubmitting,
                                    onClick = {

                                        if (!validateForm()) return@UpdatedButton

                                        scope.launch {
                                            try {
                                                isSubmitting = true

                                                loadRecaptcha().await()
                                                val recaptchaToken = Grecaptcha.execute(
                                                    "6LcwctIqAAAAAC5mssKPIFkEoH1ibmotnFEyu9gA",
                                                    js("{ action: 'job_application' }")
                                                ).await()

                                                // Build payload WITH token
                                                val payload = SendEmailPayload(
                                                    to = "info@devxertech.com",
                                                    subject = "HR Intern Application",
                                                    message = """
                                                    Name: $nameInput
                                                    Email: $emailInput
                                                    Contact: $fullContact
                                                    Position: $positionInput
                                                    """.trimIndent(),
                                                    recaptchaToken = recaptchaToken,
                                                    attachment = Attachment(
                                                        filename = selectedFileName!!,
                                                        contentType = selectedFileType ?: "application/pdf",
                                                        data = selectedFileBase64!!
                                                    )
                                                )

                                                // Call API
                                                val responseText = httpJsonRequest(
                                                    url = "https://devxer.com/api/send-email",
                                                    method = APIMETHODS.POST,
                                                    body = Json.encodeToString(payload)
                                                )

                                                if (!responseText.isNullOrBlank()) {
                                                    val response =
                                                        Json.decodeFromString<SendEmailResponse>(responseText)

                                                    if (response.success) {
                                                        // Clear form
                                                        nameInput = ""
                                                        emailInput = ""
                                                        phoneNumber = ""
                                                        positionInput = ""
                                                        selectedFileName = null
                                                        selectedFileBase64 = null
                                                        selectedFileType = null
                                                        selectedCountry = countries.firstOrNull { it.iso == "PK" || it.dialCode == "+92" }

                                                    }
                                                }

                                            } catch (e: Exception) {
                                                console.error("Application submit failed", e)
                                            } finally {
                                                isSubmitting = false
                                            }
                                        }
                                    }
                                )
                            }
                        }
                    }
                }

            }
            RatingSection(breakpoint)
            HomepageFooter(breakpoint)
        }
    }
}


@Composable
fun SectionContent(text: String, isParagraph: Boolean = false) {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    val horizontalPadding = if (breakpoint <= Breakpoint.MD) 40.px
    else if (breakpoint == Breakpoint.LG) 25.px else 100.px
    val fontSize = when {
        window.screen.width > 1600 -> 25.px
        window.screen.width > 1400 -> 23.px
        window.screen.width == 1024 -> 20.px
        window.screen.width == 768 -> 18.px
        window.screen.width < 768 -> 17.px
        else -> 16.px
    }
    val textFontSize = when {
        window.screen.width > 1600 -> 18.px
        window.screen.width == 1440 -> 16.px
        window.screen.width == 1024 -> 15.px
        window.screen.width <= 768 -> 14.px
        else -> 15.px
    }
    val marginValue = when {
        window.screen.width > 1600 -> (-2).px
        window.screen.width > 1400 -> 0.px
        else -> 0.px
    }
    val dotFontSize = when {
        window.screen.width > 1600 -> 20.px
        else -> 16.px
    }


    Row(
        modifier = Modifier
            .fillMaxWidth(if (isParagraph) 90.percent else 100.percent)
            .padding(
                left = horizontalPadding,
                top = if (isParagraph) 10.px else if (breakpoint < Breakpoint.MD) 15.px else 30.px
            )
    ) {
        if (isParagraph) {
            SpanText(
                "•",
                modifier = Modifier
                    .fontSize(dotFontSize)
                    .fontWeight(FontWeight.Bold)
                    .margin(right = 8.px, top = marginValue)
                    .color(Palette.Black.rgbLight)
            )
            FieldTitleTextNormalSimple(
                text = text,
                color = Palette.Black.rgbLight,
                fontFamily = Constants.FONT_FAMILY,
                fontSize = textFontSize,
                fontWeight = 300,
                textAlign = TextAlign.Left,
                whiteSpace = WhiteSpace.PreWrap,
            )
        } else {
            FieldTitleTextNormalSimple(
                text = text,
                color = sitePalette.commonSecondaryButtonColor.rgb,
                fontFamily = Constants.FONT_FAMILY,
                fontSize = fontSize,
                fontWeight = 700,

                )
        }
    }
}


@Composable
fun FileUploadRow(
    breakpoint: Breakpoint,
    selectedFileName: String?,
    onFileSelected: (fileName: String?, fileType: String?, base64: String?) -> Unit,
) {
    val sitePalette = ColorMode.current.toSitePalette()
//    var selectedFileName by remember { mutableStateOf<String?>(null) }
    val inputId = "file-input"

    Row(
        modifier = Modifier.fillMaxWidth(),
        verticalAlignment = Alignment.Bottom
    ) {
        // Box to trigger file input
        Box(
            modifier = Modifier
                .width(if (breakpoint > Breakpoint.MD) 184.px else 145.px)
                .height(if (breakpoint > Breakpoint.MD) 40.px else 35.px)
                .padding(leftRight = if (breakpoint > Breakpoint.LG) 10.px else 0.px)
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .cursor(Cursor.Pointer)
                .onClick {
                    val fileInput = document.getElementById(inputId) as? HTMLInputElement
                    fileInput?.click()
                },
            contentAlignment = Alignment.Center
        ) {
            FieldTitleTextNormalSimple(
                "Choose File",
                fontSize = if (breakpoint > Breakpoint.MD) 16.px else 14.px,
                color = sitePalette.topBarMenuText.rgb,
                isClickable = true
            )
        }

        // Hidden actual input
        Input(
            type = InputType.File,
            attrs = {
                id(inputId)
                attr("accept", ".pdf,.doc,.docx")
                style { display(DisplayStyle.None) }
                onChange {
                    val input = it.target
                    val file = input.files?.item(0)

                    if (file != null) {
                        val reader = js("new FileReader()")

                        reader.onload = {
                            val result = reader.result as String
                            val base64 = result.substringAfter(",")

                            onFileSelected(
                                file.name,
                                file.type,
                                base64
                            )
                        }

                        reader.readAsDataURL(file)
                    }
                }


            }
        )

        // Filename or placeholder
        Row(
            modifier = Modifier.fillMaxWidth()
                .borderBottom(1.px, LineStyle.Solid, sitePalette.bodyBackground.rgb)
                .height(if (breakpoint > Breakpoint.MD) 40.px else 35.px)
                .padding(leftRight = 12.px)
                .backgroundColor(Colors.Transparent),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Box(
                modifier = Modifier
                    .flexGrow(1.0)
                    .overflow(Overflow.Hidden)
                    .whiteSpace(WhiteSpace.NoWrap)
                    .textOverflow(TextOverflow.Ellipsis)
            ) {
                SpanText(
                    text = selectedFileName ?: "No file chosen",
                    modifier = Modifier
                        .fontSize(if (breakpoint > Breakpoint.MD) 18.px else 16.px)
                        .fontFamily(Constants.FONT_FAMILY)
                        .color(Colors.White)
                        .cursor(Cursor.Pointer).padding(left = 5.px)
                )
            }
            if (selectedFileName != null) {
                FaXmark(
                    modifier = Modifier
                        .margin(left = 8.px)
                        .color(sitePalette.commonSecondaryButtonColor.rgb)
                        .cursor(Cursor.Pointer)
                        .onClick {
                            onFileSelected(null, null, null)
                            (document.getElementById(inputId) as? HTMLInputElement)?.value = ""
                        }

                )
            }
        }
    }
}


